var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TopBarSection',{attrs:{"borderRight":true}},[_c('StandardButton',{staticClass:"open-elements-toolbar-button",attrs:{"active":_vm.isAddSectionOpen,"size":"22","testId":"open-elements-toolbar-button"},on:{"click":_vm.toggleAdd}},[_vm._v(" Add ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }